/*
 * @Author: guanxiaoyan guanxiaoyan@pb-station.com
 * @Deion: 
 * @Date: 2023-12-28 20:59:58
 * @LastEditors: guanxiaoyan guanxiaoyan@pb-station.com
 * @LastEditTime: 2024-01-24 15:01:11
 * @FilePath: /ywx-open/vueproject/src/api/admin/index.js
 */
import request from "@/utils/followUp/request";

// 字典管理
export * from "./dictManage/dept";
export * from "./dictManage/hosp";
export * from "./dictManage/disease";

// 用户管理
export * from "./userManage/staff";
export * from "./userManage/role";
export * from "./userManage/account";
export * from "./userManage/menu";

// 随访统计``````
export * from "./statisticalManage/followupStatistical";

// 根据院区ID获取科室
export function getTreeHospDept(query) {
  return request({
    url: `/internal/hospDept/all-list-children-by-ward`,
    method: "get",
    params: query,
  });
}

// 我的账户信息例子
export function getAuthInfo1(query) {
  return request({
    url: `/user/getAuthInfo`,
    method: "get",
    params: query,
    needClientId: true
  });
}
export function fileUpload(file, namespace) {
  // namespace = window.adminHtml ? "internal" : "sf-work" + namespace;
  // eslint-disable-next-line no-param-reassign
  namespace = `internal${namespace}`;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("namespace", namespace);
  return request({
    url: `/file/upload`,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 获取文章详情
export function getArticleTemp(id) {
  return request({
    url: `/common/article-temp/detail/${id}`,
    method: "get",
  });
}
// 获取文章详情
export function getArticleSnapshot(id) {
  return request({
    url: `/common/article-snapshot/detail/${id}`,
    method: "get",
  });
}
    // 医院二维码
export function generateQrcode() {
  return request({
    url: `/hosp/generate-qrcode`,
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
